<template>
    <div class="forget_box">
        <el-card>
            <!-- 标题 -->
            <template slot="header">
                <div class="forget_title">{{$t("message.forget.title")}}</div>
            </template>
            <!-- 表单 -->
            <el-form 
                :model="forgetForm"
                :rules="rules"
                ref="forgetForm"
                size="medium">
                <!-- 用户名 -->
                <el-form-item prop="uname">
                    <el-input
                        v-model="forgetForm.uname"
                        ref="uname"
                        :placeholder="$t('message.forget.form1')"
                        prefix-icon="glyphicon glyphicon-user"
                        @keyup.enter.native="$refs.email.focus()"
                        autofocus
                        clearable>
                    </el-input>
                </el-form-item>
                <!-- 密码 -->
                <el-form-item prop="email">
                    <el-input
                        v-model="forgetForm.email"
                        ref="email"
                        :placeholder="$t('message.forget.form2')"
                        prefix-icon="glyphicon glyphicon-envelope"
                        @keyup.enter.native="forget"
                        clearable>
                    </el-input>
                </el-form-item>
                <!-- 登录按钮 -->
                <el-form-item>
                    <el-button 
                        type="primary"
                        @click="forget"
                        class="forget_go_btn">
                        <span>{{$t("message.forget.submitBtn")}}</span>
                    </el-button>
                </el-form-item>
                <!-- 立即注册 -->
                <el-form-item>
                    <div class="forget_go_register">
                        <span>{{$t("message.forget.havenot")}}</span>
                        <el-button
                            type="text"
                            @click="$router.push('/register')">
                            <span>{{$t("message.forget.register")}}</span>
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    data() {
        return {
            forgetForm: {
                uname: "",
                email: "",
            },
            rules: {
                uname: [
                    {required:true, message: this.$t("message.forget.rule1"), trigger: "blur"}
                ],
                email: [
                    {required:true, message: this.$t("message.forget.rule2"), trigger: "blur"}
                ]
            }
        }
    },
    computed: mapState({
        islogin: state => state.user.islogin,
    }),
    methods: {
        ...mapActions([
            "sendForget"
        ]),
        // 
        forget(){
            this.$refs.forgetForm.validate((valid) => {
                if (valid) {
                    this.sendForget({
                        username: this.forgetForm.uname,
                        email: this.forgetForm.email
                    }).then((res) => {
                        if(res.type){
                            this.$message({
                                showClose: true,
                                message: this.$t("message.forget.succmsg"),
                                type: "success"
                            })
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: "error"
                            })
                        }
                    })
                } else {
                    return false;
                }
            });
        },
    },
    beforeRouteEnter (to, from, next) {
        // ...
        next(vm => {
            if(vm.isLogin){
                vm.$router.replace({name: "main"})
            }
        })
    },
    beforeRouteLeave (to, from, next) {
        this.forgetForm = {
            uname: "",
            email: "",
        }
        next();
    }
}
</script>

<style scoped>
/* 组件盒子 */
.forget_box{
    width: 340px;
    margin: 60px auto;
}
/* 标题 */
.forget_title{
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #606266;
}
/* 忘记密码按钮 */
.forget_btn{
    float: right;
}
/* 立即登录按钮 */
.forget_go_btn{
    width: 100%;
}
/* 立即注册 */
.forget_go_register{
    text-align: center
}
</style>
